import React from 'react';
import Header from './components/header';
import Hero from './components/hero';
import './styles/App.css';

function App() {
  return (
    <>
      <Header />
      <Hero />
    </>
  );
}

export default App;
